var map = {
	"./CNPrinter.png": "./src/assets/imgs/CNPrinter.png",
	"./GroupGo.png": "./src/assets/imgs/GroupGo.png",
	"./add.png": "./src/assets/imgs/add.png",
	"./addActive.png": "./src/assets/imgs/addActive.png",
	"./addCloudPrinter.png": "./src/assets/imgs/addCloudPrinter.png",
	"./addIcon.png": "./src/assets/imgs/addIcon.png",
	"./backIcon.png": "./src/assets/imgs/backIcon.png",
	"./closeIcon.png": "./src/assets/imgs/closeIcon.png",
	"./control_add.png": "./src/assets/imgs/control_add.png",
	"./firmwareUpdate/ACEPro.png": "./src/assets/imgs/firmwareUpdate/ACEPro.png",
	"./firmwareUpdate/K3.png": "./src/assets/imgs/firmwareUpdate/K3.png",
	"./get-notifications.png": "./src/assets/imgs/get-notifications.png",
	"./head_icon.png": "./src/assets/imgs/head_icon.png",
	"./home.png": "./src/assets/imgs/home.png",
	"./homeGo.png": "./src/assets/imgs/homeGo.png",
	"./icon-continue.png": "./src/assets/imgs/icon-continue.png",
	"./icon-continuing.png": "./src/assets/imgs/icon-continuing.png",
	"./icon-pausing.png": "./src/assets/imgs/icon-pausing.png",
	"./icon-skip.png": "./src/assets/imgs/icon-skip.png",
	"./icon-stop.png": "./src/assets/imgs/icon-stop.png",
	"./icon-stoping.png": "./src/assets/imgs/icon-stoping.png",
	"./icon-suspend.png": "./src/assets/imgs/icon-suspend.png",
	"./information.png": "./src/assets/imgs/information.png",
	"./lanIcon.png": "./src/assets/imgs/lanIcon.png",
	"./loading.png": "./src/assets/imgs/loading.png",
	"./log-out-hover.png": "./src/assets/imgs/log-out-hover.png",
	"./log-out.png": "./src/assets/imgs/log-out.png",
	"./login-background.png": "./src/assets/imgs/login-background.png",
	"./materialsEdit.png": "./src/assets/imgs/materialsEdit.png",
	"./more.png": "./src/assets/imgs/more.png",
	"./moreInfo/icon-CN.png": "./src/assets/imgs/moreInfo/icon-CN.png",
	"./moreInfo/icon-Mac.png": "./src/assets/imgs/moreInfo/icon-Mac.png",
	"./moreInfo/icon-bindTime.png": "./src/assets/imgs/moreInfo/icon-bindTime.png",
	"./moreInfo/icon-firmware.png": "./src/assets/imgs/moreInfo/icon-firmware.png",
	"./moreInfo/icon-longtime.png": "./src/assets/imgs/moreInfo/icon-longtime.png",
	"./moreInfo/icon-printeTimes.png": "./src/assets/imgs/moreInfo/icon-printeTimes.png",
	"./moreInfo/icon-wireRod.png": "./src/assets/imgs/moreInfo/icon-wireRod.png",
	"./noPrinter.png": "./src/assets/imgs/noPrinter.png",
	"./noPrinterLists.png": "./src/assets/imgs/noPrinterLists.png",
	"./opBg.png": "./src/assets/imgs/opBg.png",
	"./openIcon.png": "./src/assets/imgs/openIcon.png",
	"./pause.png": "./src/assets/imgs/pause.png",
	"./printers/Kobra2_Max_thumbnail.png": "./src/assets/imgs/printers/Kobra2_Max_thumbnail.png",
	"./printers/Kobra2_Plus_thumbnail.png": "./src/assets/imgs/printers/Kobra2_Plus_thumbnail.png",
	"./printers/Kobra2_Pro_thumbnail.png": "./src/assets/imgs/printers/Kobra2_Pro_thumbnail.png",
	"./printers/Kobra3_thumbnail.png": "./src/assets/imgs/printers/Kobra3_thumbnail.png",
	"./printers/Kobra_s1.png": "./src/assets/imgs/printers/Kobra_s1.png",
	"./printers/s1.png": "./src/assets/imgs/printers/s1.png",
	"./reScan.png": "./src/assets/imgs/reScan.png",
	"./reduce.png": "./src/assets/imgs/reduce.png",
	"./reduceActive.png": "./src/assets/imgs/reduceActive.png",
	"./remote-printing.png": "./src/assets/imgs/remote-printing.png",
	"./rightIcon.png": "./src/assets/imgs/rightIcon.png",
	"./right_arrow.png": "./src/assets/imgs/right_arrow.png",
	"./search.png": "./src/assets/imgs/search.png",
	"./signal-one.png": "./src/assets/imgs/signal-one.png",
	"./signal-three.png": "./src/assets/imgs/signal-three.png",
	"./signal-two.png": "./src/assets/imgs/signal-two.png",
	"./skip-check-left.png": "./src/assets/imgs/skip-check-left.png",
	"./skip-check-right.png": "./src/assets/imgs/skip-check-right.png",
	"./skip-finish.png": "./src/assets/imgs/skip-finish.png",
	"./skip-info.png": "./src/assets/imgs/skip-info.png",
	"./skipSelect.png": "./src/assets/imgs/skipSelect.png",
	"./skiped.png": "./src/assets/imgs/skiped.png",
	"./skipedDark.png": "./src/assets/imgs/skipedDark.png",
	"./skiping.png": "./src/assets/imgs/skiping.png",
	"./square.png": "./src/assets/imgs/square.png",
	"./stop.png": "./src/assets/imgs/stop.png",
	"./succeed.png": "./src/assets/imgs/succeed.png",
	"./switch.png": "./src/assets/imgs/switch.png",
	"./tab.png": "./src/assets/imgs/tab.png",
	"./task_default.png": "./src/assets/imgs/task_default.png",
	"./test.png": "./src/assets/imgs/test.png",
	"./timeIcon.png": "./src/assets/imgs/timeIcon.png",
	"./top_1.png": "./src/assets/imgs/top_1.png",
	"./user_default.png": "./src/assets/imgs/user_default.png",
	"./video-monitor.png": "./src/assets/imgs/video-monitor.png",
	"./wireRodIcon.png": "./src/assets/imgs/wireRodIcon.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs sync recursive ^\\.\\/.*\\.png$";